import React, { useState, useEffect } from 'react';
import './ChatBot.css';

const ChatBot = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // Load Noform.ai script on component mount
  useEffect(() => {
    if (!scriptLoaded) {
      const script = document.createElement('script');
      script.defer = true;
      script.type = 'text/javascript';
      script.id = 'chatbot-initials-script';
      script.src = 'https://chat-bbl.noform.ai/script-chatbot.js';
      script.setAttribute('data-server-url', 'https://app.noform.ai');
      script.setAttribute('data-bot-id', '688d741a9761674893bce473');
      
      script.onload = () => {
        setScriptLoaded(true);
      };

      script.onerror = () => {
      };
      
      document.head.appendChild(script);
    }
  }, [scriptLoaded]);

  // Return null since we only want the Noform.ai script to create its own button
  return null;
};

export default ChatBot; 